import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { PdpState, PdpStore } from '@ff-os/pdp-shared-redux/store';
import { scenePlugins } from '@ff-os/pdp-shared-registry/index';
import { Pdp } from '@ff-os/pdp-shared-registry/Pdp';

const _PreviewSlot = ({ ui }: Props) => {
    const PreviewUi = ui.preview;
    if (PreviewUi) {
        return <PreviewUi />;
    } else {
        return null;
    }
};

type Props = {
    ui: Pdp.Scene.Plugin<unknown>['ui'];
};

const mapStateToProps = (state: PdpState) => ({
    ui: selectUiByScenePluginId(state)
});

const selectUiByScenePluginId = createSelector([
    (state: PdpState) => state.scene.pluginId
], scenePluginId => {
    const plugin = scenePlugins.require(scenePluginId);
    return plugin.ui;
});

export const hasPreview = ({ getState }: PdpStore) => {
    const { preview } = selectUiByScenePluginId(getState());
    return preview !== null;
};

export const PreviewSlot = connect(
    mapStateToProps
)(_PreviewSlot);